module.exports = __webpack_public_path__ + "static/img/img-3-4.d2a5caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3-4.png
// module id = NQl8
// module chunks = 0